import React, { Component, useState, useEffect } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import CommonAlert from "../common/Commonalert";
import Sidebar from "../common/sidebar";
import ShowAlert from "../common/Showalert";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const MasterEntryAdd = () => {
  const { t } = useTranslation();
  const { name } = useParams();
  const [MasterValue, setMasterValue] = useState("");
  const [MasterCategory, setMasterCategory] = useState([]);
  const [MasterImage, setMasterImage] = useState(null);
  const [datalist, setDataList] = useState([]);
  const [errormsg, setErrormsg] = useState({});
  const [errors, setErrors] = useState({});
  const [errmessage, setErrMessage] = useState({});
  const [alertPopup, setAlertPopup] = useState(false);
  const [alerterrorPopup, setAlertErrorPopup] = useState(false);
  const [alerterrMessage, setAlerterrMessage] = useState([]);
  const [alertMessage, setAlertMessage] = useState([]);

  if (!sessionStorage.getItem("isLoggedIn")) window.location.href = "/";
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_masterentry")
  ) {
    window.location.href = "/unauthorized";
  }

  const routeChange = () => {
    window.location.href = `/master-entry/${name}`;
  };

  useEffect(() => {
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    setMasterCategory(
      name === "productgroup"
        ? t("product_group_txt")
        : name === "suitablefor"
          ? t("suitable_for_txt")
          : name === "taxcode"
            ? t("tax_code_txt")
            : t("sector_txt"),
    );
    let URL = BaseUrl + `admin/product/masterentries/${name}`;
    http
      .get(URL)
      .then((response) => {
        let responseData = response.data.data;

        setDataList(responseData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [t, name]);

  const btnsubmit = (e) => {
    e.preventDefault();
    const isValid = formvalidation();
    if (isValid) {
      let mastervalue = MasterValue.trim();
      let payload = new FormData();
      payload.append("MasterCategory", name);
      payload.append("MasterValue", mastervalue);
      if (name === "sectors" && MasterImage) {
        payload.append("MasterImage", MasterImage);
      }
      const isFound = datalist.some((element) => {
        if (element.MasterValue.toLowerCase() === mastervalue.toLowerCase()) {
          return true;
        }
        return false;
      });
      if (isFound) {
        setAlertErrorPopup(true);
        setAlerterrMessage(t("data_already_exists_txt"));
      } else {
        var loginDetails = {};
        if (sessionStorage.getItem("authData")) {
          loginDetails = JSON.parse(sessionStorage.getItem("authData"));
        }
        let URL = BaseUrl + "admin/product/addmaster/";
        http
          .post(URL, payload, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then(async (response) => {
            if (response.data.success === true) {
              setAlertPopup(true);
              setAlertMessage(
                t("master_category_added_successfully_txt", {
                    category: MasterCategory,
                })
              );
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  };

  const formvalidation = () => {
    const errmsg = {};
    let isValid = true;
    if (!MasterValue.trim()) {
      errmsg.MasterValue = t("field_required_txt");
      isValid = false;
    }
    setErrors(errmsg);
    return isValid;
  };

  const handleOnChange = (e) => {
    const re = /^[a-zA-Z0-9-' &.]*$/;
    if (e.target.name === "MasterValue") {
      if (e.target.value === "" || re.test(e.target.value)) {
        setMasterValue(e.target.value);
      }
    }
    const { name, value } = e.target;
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  return (
    <section className="dashboard-block">
      {alerterrorPopup && <ShowAlert title={t("alert_txt")} message={alerterrMessage} />}
      {alertPopup && <CommonAlert title={t("alert_txt")} message={alertMessage} />}
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container account-details">
            <h1 className="checkout-title">{t("add_txt")} {MasterCategory}</h1>
            <div className="right-table-outer-wrap">
              <div className="form-field freeproduct-fieldset masterentry-fieldset form-container-xs">
                <form className="sectors-detail-form">
                  <div className="input-field">
                    <label htmlFor="name">{MasterCategory}</label>
                    <input
                      type="text"
                      name="MasterValue"
                      value={MasterValue}
                      onChange={handleOnChange}
                    />
                    {errors.MasterValue && (
                      <div className="error-msg">{errors.MasterValue}</div>
                    )}
                  </div>
                  {name === "sectors" && (
                    <div className="input-field">
                      <label>{t("sector_image_txt")}</label>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => setMasterImage(e.target.files[0])}
                      />
                      {MasterImage && (
                        <img
                          src={URL.createObjectURL(MasterImage)}
                          alt={t("preview_txt")}
                          style={{ width: "80px", marginTop: "10px" }}
                        />
                      )}
                    </div>
                  )}
                  <div className="btnfield">
                    <button title={t("submit_txt")} type="submit" name="btnsubmit" onClick={btnsubmit}>
                      {t("submit_txt")}
                    </button>
                    <button title={t("cancel_txt")} type="button" onClick={routeChange}>
                      {t("cancel_txt")}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <Footer />
        </section>
      </div>
    </section>
  );
};

export default MasterEntryAdd;
